// ========================================================
// FAST HIT Website — Privacy-First Analytics Service (Phase 9)
// Lightweight, privacy-respecting metrics with explicit consent
// ========================================================

const CONSENT_KEY = 'fasthit_analytics_consent';

export function hasAnalyticsConsent(): boolean {
  return localStorage.getItem(CONSENT_KEY) === 'granted';
}

export function setAnalyticsConsent(granted: boolean): void {
  localStorage.setItem(CONSENT_KEY, granted ? 'granted' : 'denied');
}

export type AnalyticsEventType =
  | 'page_view'
  | 'search_performed'
  | 'match_scorecard_viewed'
  | 'tournament_registered'
  | 'cta_clicked'
  | 'community_post_created';

export function trackEvent(
  eventType: AnalyticsEventType,
  properties: Record<string, string | number | boolean> = {}
): void {
  if (!hasAnalyticsConsent()) {
    // Respect user privacy consent: do not log if not granted
    return;
  }

  const payload = {
    event: eventType,
    properties: {
      ...properties,
      timestamp: new Date().toISOString(),
      referrer: document.referrer || undefined,
      path: window.location.pathname,
    },
  };

  // Safe client-side telemetry buffer
  if (import.meta.env.DEV) {
    console.debug('[FAST HIT Analytics Event]', payload);
  }
}
